// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"90fa3024","175":"ae69aa7e","233":"ac2c5d87","369":"eb8bc285","777":"d85915b3","936":"806de948"}[chunkId] + ".js";
};